export const Numbers = {
    isNumber: (test) => !Number.isNaN(Number(test)),
    noIntlToUSD: (num) => {
        const amount = Numbers.roundTo(num, 2).toString();
        // eslint-disable-next-line prefer-const
        let [dollars, cents] = amount.split('.');
        if (dollars.length > 3) {
            const reverseDollars = dollars.split('').reverse();
            const prettyDollars = [];
            const max = reverseDollars.length - 1;
            reverseDollars.forEach((el, i) => (i !== max && (i + 1) % 3 === 0 && i !== 0
                ? prettyDollars.unshift(`,${el}`)
                : prettyDollars.unshift(el)));
            dollars = prettyDollars.join('');
        }
        return `$${dollars}.${cents}`;
    },
    roundTo: (n, digits = 0) => {
        const multiplier = 10 ** digits;
        const newN = parseFloat((n * multiplier).toFixed(11));
        const test = Math.round(newN) / multiplier;
        return +test.toFixed(digits);
    },
    toUSD: (num, decimalPlaces = 2) => (new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimalPlaces,
    }).format(num)),
    toDisplay: (num) => new Intl.NumberFormat('en-US').format(num),
    toPercentage: (num, decimalPlaces = 2) => (`${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    }).format(num * 100)}%`),
    dollarsToCents: (dollars) => Math.round(dollars * 100),
    centsToDollars: (cents) => Numbers.roundTo(cents / 100, 2),
    getGreater: (a, b) => (a > b ? a : b),
};
